export function executeCopyToClipboard(plainText: string, htmlText: string, richtextFontSize: number | undefined): Promise<void> {
    if (richtextFontSize) {
        htmlText = `<div style="font-size: ${richtextFontSize}pt;"><style>ul {margin-top: 0; margin-bottom: 0;} p { margin-bottom: 0;}</style>${htmlText}</div>`
    }

    return navigator.clipboard.write([new ClipboardItem({
        'text/plain': new Blob([plainText], { type: 'text/plain' }),
        'text/html': new Blob([htmlText], { type: 'text/html' }),
    })]);
}